module.exports = __webpack_public_path__ + "img/steering-wheel.8b5ec187.svg";